import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import Box from '@/components/Box';
import Comment from '@/components/Comment';
interface Props {
  avatarUrl?: string;
  author: string;
  message: string;
  created?: Date;
}

const CommentContainer = styled(Box)`
  .ant-comment-inner {
    padding: 4px 0;
  }
`;

function MessagePreview({
  avatarUrl,
  author,
  message,
  created,
}: Props): React.ReactElement {
  const preview = useMemo(
    () =>
      // Simple truncation to 60 characters
      message.length > 60 ? `${message.substring(0, 60)}...` : message,
    [message],
  );

  return (
    <CommentContainer>
      <Comment
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: preview,
            }}
          />
        }
        author={author}
        avatarUrl={avatarUrl}
        datetime={dayjs(created).fromNow()}
      />
    </CommentContainer>
  );
}

export default MessagePreview;
